import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {
  DocumentInformation,
  DossierBloqueDto,
  DossierBloquerRequest,
  FileProperties,
  IDossierWebServiceClient,
  ResultFixedAnomaliesDto
} from "@resources/resources";
import {EtatEnums} from "@common/enum/Etat.enum";

@Component({
  selector: 'body-documents-manquants',
  templateUrl: './body-documents-manquants.html'
})
export class BodyDocumentsManquants implements OnInit {
  apiResult: ResultFixedAnomaliesDto;
  fileLoading: boolean;
  fileLoaded = false;
  fileName: string;
  maxSizeFile: number; //octets
  oversize: boolean;
  serverError: boolean;
  file: File;
  wrongType: boolean;
  showMotifRejet: boolean;
  fileExist: boolean;
  allowedTypes: string[];

  @Input() dossierBloqueDto: DossierBloqueDto;
  @Input() fileProperties: FileProperties;
  @Input() statusPopup: EtatEnums;
  @Output() documentInformations = new EventEmitter<DocumentInformation>();
  @Output() shouldRefresh: EventEmitter<any> = new EventEmitter();


  constructor(private dossierBloqueService: IDossierWebServiceClient) {
  }

  ngOnInit() {
    this.showMotifRejet = this.dossierBloqueDto.motifRejet ? true : false;
    this.maxSizeFile = +this.fileProperties.fileMaxSize;
    this.allowedTypes = this.fileProperties.fileExtensions.split(', ');

    if (this.dossierBloqueDto.etat === EtatEnums.A_VALIDER.value()) {
      this.fileExist = true;
    }
  }

  isEtatTermine() {
    return this.statusPopup == EtatEnums.TERMINE;
  }

  isEtatEnCours() {
    return this.statusPopup == EtatEnums.EN_COURS;
  }

  isEtatAValider() {
    return this.statusPopup == EtatEnums.A_VALIDER;
  }

  isLocked() {
    return this.dossierBloqueDto.lock == true;
  }

  isAllowedType(type: string) {
    return this.allowedTypes.join('').includes(type.split('/')[1]);
  }

  uploadFile(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      this.showMotifRejet = false;
      this.wrongType = false;

      if (!this.isAllowedType(file.type)) {
        this.wrongType = true;
        return;
      }

      this.serverError = false;
      this.oversize = file.size >= this.maxSizeFile * 1000000;

      if (!this.oversize) {

        this.file = file;
        this.fileName = file.name;

        this.fileLoading = true;
        this.dossierBloqueDto.nomFichier = file.name;
        this.dossierBloqueService.fixDocumentAnomalies(this.dossierBloqueDto, file).subscribe(
          result => {
            this.apiResult = result;
            this.fileLoaded = true;
            this.fileLoading = false;
            this.fileExist = true;
            this.documentInformations.emit(this.getDocumentInformation('ADD'));
            this.shouldRefresh.emit();
            this.dossierBloqueDto.etat = EtatEnums.A_VALIDER.value();
          }, err => {
            this.fileLoaded = false;
            this.fileLoading = false;
            this.serverError = true;
          }
        );
      } else {
        this.fileName = this.dossierBloqueDto.nomFichier;
      }
    }
  }

  getDocumentInformation(action: string): DocumentInformation {
    let documentInfo = {
      numeroDossier: this.dossierBloqueDto.numeroDossier,
      cleLigneAnalyseResultat: this.dossierBloqueDto.cleLigneAnalyseResultat,
      codeCorrespondant: this.dossierBloqueDto.codeCorrespondant,
      action: action
    } as DocumentInformation;
    return documentInfo;
  }

  //download file from server
  saveFile() {
    if (this.file) {
      if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(this.file instanceof Blob, this.file.name);
      } else {
        let url = window.URL.createObjectURL(this.file);
        var anchor = document.createElement("a");
        anchor.download = this.file.name;
        anchor.target = '_blank';
        anchor.href = url;

        anchor.dispatchEvent(new MouseEvent("click"));
      }
    }
  }

  deleteFile(deleteFromList: boolean) {
    this.dossierBloqueService.deleteFileDossierBloque(this.dossierBloqueDto).subscribe(
      result => {
        this.fileExist = false;
        this.apiResult = result;
        this.fileLoaded = false;
        this.dossierBloqueDto.etat = EtatEnums.EN_COURS.value();
        this.oversize = false;
        this.serverError = false;
        this.wrongType = false;
        this.shouldRefresh.emit();
        if (deleteFromList == true) {
          this.documentInformations.emit(this.getDocumentInformation('DELETE'));
        } else {
          this.documentInformations.emit(this.getDocumentInformation('ADD'));
        }
      }, err => {
        this.fileLoaded = true;
      }
    );
  }

  getCorrespondantSaisie() {
    return this.dossierBloqueDto.codeCorrespondantSaisie;
  }

  downloadFile() {
    let documentRequest = {
      numeroDossier: this.dossierBloqueDto.numeroDossier,
      cleLigneAnalyseResultat: this.dossierBloqueDto.cleLigneAnalyseResultat,
      codeCorrespondant: this.dossierBloqueDto.codeCorrespondant
    } as DossierBloquerRequest;

    this.dossierBloqueService.downloadFile(documentRequest).subscribe(res => {
      if (res) {
        if (window.navigator.msSaveBlob) {
          window.navigator.msSaveBlob(res, this.dossierBloqueDto.nomFichier);
        } else {
          let url = window.URL.createObjectURL(res);
          var anchor = document.createElement("a");
          anchor.download = this.dossierBloqueDto.nomFichier;
          anchor.target = '_blank';
          anchor.href = url;
          anchor.dispatchEvent(new MouseEvent("click"));
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/common/utils/dialog/dialog-donnees-manquantes/body-documents-manquants/body-documents-manquants.ts